/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteSecurityFile } from '../fn/files-storage/delete-security-file';
import { DeleteSecurityFile$Params } from '../fn/files-storage/delete-security-file';
import { FileDownloadResponse } from '../models/file-download-response';
import { getAuthSupportsRequestFile } from '../fn/files-storage/get-auth-supports-request-file';
import { GetAuthSupportsRequestFile$Params } from '../fn/files-storage/get-auth-supports-request-file';
import { getSecurityFile } from '../fn/files-storage/get-security-file';
import { GetSecurityFile$Params } from '../fn/files-storage/get-security-file';
import { getStationSecurityFileslist } from '../fn/files-storage/get-station-security-fileslist';
import { GetStationSecurityFileslist$Params } from '../fn/files-storage/get-station-security-fileslist';
import { SecurityFileUploadResponse } from '../models/security-file-upload-response';
import { StationSecurityFilesList } from '../models/station-security-files-list';
import { storeSecurityFile } from '../fn/files-storage/store-security-file';
import { StoreSecurityFile$Params } from '../fn/files-storage/store-security-file';


/**
 * All about files storage
 */
@Injectable({ providedIn: 'root' })
export class FilesStorageService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAuthSupportsRequestFile()` */
  static readonly GetAuthSupportsRequestFilePath = '/custom/auth-supports-requests/{uid}/getFile';

  /**
   * Get a PDF security file for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthSupportsRequestFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportsRequestFile$Response(params: GetAuthSupportsRequestFile$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDownloadResponse>> {
    return getAuthSupportsRequestFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a PDF security file for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthSupportsRequestFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportsRequestFile(params: GetAuthSupportsRequestFile$Params, context?: HttpContext): Observable<FileDownloadResponse> {
    return this.getAuthSupportsRequestFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileDownloadResponse>): FileDownloadResponse => r.body)
    );
  }

  /** Path part for operation `getStationSecurityFileslist()` */
  static readonly GetStationSecurityFileslistPath = '/custom/station/{uid}/SecurityFile/getFilesList';

  /**
   * The list of security files for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationSecurityFileslist()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationSecurityFileslist$Response(params: GetStationSecurityFileslist$Params, context?: HttpContext): Observable<StrictHttpResponse<StationSecurityFilesList>> {
    return getStationSecurityFileslist(this.http, this.rootUrl, params, context);
  }

  /**
   * The list of security files for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationSecurityFileslist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationSecurityFileslist(params: GetStationSecurityFileslist$Params, context?: HttpContext): Observable<StationSecurityFilesList> {
    return this.getStationSecurityFileslist$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationSecurityFilesList>): StationSecurityFilesList => r.body)
    );
  }

  /** Path part for operation `getSecurityFile()` */
  static readonly GetSecurityFilePath = '/custom/station/{uid}/SecurityFile';

  /**
   * Get a PDF security file for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSecurityFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSecurityFile$Response(params: GetSecurityFile$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDownloadResponse>> {
    return getSecurityFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a PDF security file for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSecurityFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSecurityFile(params: GetSecurityFile$Params, context?: HttpContext): Observable<FileDownloadResponse> {
    return this.getSecurityFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileDownloadResponse>): FileDownloadResponse => r.body)
    );
  }

  /** Path part for operation `storeSecurityFile()` */
  static readonly StoreSecurityFilePath = '/custom/station/{uid}/SecurityFile';

  /**
   * Store a PDF security file for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeSecurityFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  storeSecurityFile$Response(params: StoreSecurityFile$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityFileUploadResponse>> {
    return storeSecurityFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Store a PDF security file for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeSecurityFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  storeSecurityFile(params: StoreSecurityFile$Params, context?: HttpContext): Observable<SecurityFileUploadResponse> {
    return this.storeSecurityFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<SecurityFileUploadResponse>): SecurityFileUploadResponse => r.body)
    );
  }

  /** Path part for operation `deleteSecurityFile()` */
  static readonly DeleteSecurityFilePath = '/custom/station/{uid}/SecurityFile';

  /**
   * Delete a PDF security file for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSecurityFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  deleteSecurityFile$Response(params: DeleteSecurityFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSecurityFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a PDF security file for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSecurityFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  deleteSecurityFile(params: DeleteSecurityFile$Params, context?: HttpContext): Observable<void> {
    return this.deleteSecurityFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
